(() => {
  const target = document.getElementById('uniforme-configurador')
  const stickies = document.querySelectorAll('[data-uniforme-sticky]')
  if (!target || stickies.length === 0) return

  const observer = new IntersectionObserver((entries) => {
    const visible = entries[0].isIntersecting
    stickies.forEach(el => el.classList.toggle('is-hidden', visible))
  }, { threshold: 0.2 })

  observer.observe(target)
})()
